module.exports = __webpack_public_path__ + "static/012.thumb-63a4d4536019ee0161a75e9389412235.jpg";